import type { SVGProps } from 'react';

const SvgPresent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12.71 8.79a.996.996 0 0 0-1.41 0l-3 3a.996.996 0 1 0 1.41 1.41L11 11.91v2.59c0 .55.45 1 1 1s1-.45 1-1v-2.59l1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41z"
    />
    <path
      fill="currentcolor"
      d="M22 17h-1.18c.11-.31.18-.65.18-1V8c0-1.65-1.35-3-3-3H6C4.35 5 3 6.35 3 8v8c0 .35.07.69.18 1H2c-.55 0-1 .45-1 1s.45 1 1 1h20c.55 0 1-.45 1-1s-.45-1-1-1M6 17c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1z"
    />
  </svg>
);
export default SvgPresent;
